<div class="rn-page power-ups-pl">
  <div class="power-ups-pl__heading">
    <h2 class="intro-line-1">Add a Power-Up</h2>
  </div>

  <div class="power-ups-pl__panels">
    <div class="power-ups-pl__panel power-ups-pl__panel--left">
      <div class="power-ups-pl__panel-heading-group">
        <div class="power-ups-pl__panel-label">Form List</div>
        <p class="power-ups-pl__panel-note">This list only includes Power-Ups configured for use in the customer feed</p>
        <div class="power-ups-pl__panel-search-bar-wrapper">
          <div class="power-ups-pl__panel-search-bar">
            <input class="power-ups-pl__search-input" name="power-ups-search" type="text" placeholder="Search" [(ngModel)]="searchTerm">
            <button class="power-ups-pl__search-clear-icon" [hidden]="searchTerm === ''" (click)="clearSearchBar()">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <ul class="rn-list rn-list-ul-outer">
        <li class="rn-list__row rn-list__row--header">
          <div class="rn-list__col">
            <span class="rn-list__heading-1">
              Name
            </span>
          </div>
        </li>
        <li class="rn-list__body">

          @if (!powerUps) {
            <p class="power-ups-pl__message">There was an error fetching forms for your client</p>
          }
          @if (powerUps && powerUps.length === 0) {
            <p class="power-ups-pl__message">There are no forms for this client</p>
          }
          @if (powerUps && powerUps.length > 0 && filteredPowerUps().length === 0) {
            <p class="power-ups-pl__message">There are no forms matching your query</p>
          }

          @if (powerUps && filteredPowerUps().length > 0) {
            <ul id="power-ups-list" class="rn-list">
              @for (powerUp of filteredPowerUps(); track powerUp) {
                <li class="rn-list__row" [class.rn-list__row--selected]="selectedPowerUpId === powerUp.id" (click)="selectPowerUp(powerUp.id)">
                  <div class="rn-list__col">{{powerUp.title}}</div>
                </li>
              }
            </ul>
          }
        </li>
      </ul>

    </div>

    @if (selectedPowerUp) {
      <div class="power-ups-pl__panel power-ups-pl__panel--right">
        <div class="power-ups-pl__panel-heading-group">
          @if (!!selectedPowerUp) {
            <h3 class="power-ups-pl__subheading">Previewing {{selectedPowerUp.title}}</h3>
          }
        </div>
        <div id="powerUpsPLiframeContainer" class="power-ups-pl__iframe-container">
          <rn-power-ups-preview [formId]="selectedPowerUp.id"></rn-power-ups-preview>
        </div>
      </div>
    }
  </div>
  <div class="power-ups-pl__btn-container">
    <button id="power-ups-preview-list-cancel-btn" class="btn power-ups-pl__btn power-ups-pl__btn--cancel" type="button" (click)="cancelAndClose()">Cancel</button>
    <button id="power-ups-preview-list-save-btn" class="btn btn-primary power-ups-pl__btn power-ups-pl__btn--select" type="button" (click)="saveAndClose()">select</button>
  </div>
</div>
